import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=77904c03&"
import script from "./UserSelect.vue?vue&type=script&lang=ts&"
export * from "./UserSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports